import { useEffect, useState } from 'react';
import { VideoCategory } from '../../../interface/video';
import { videosServices } from '../../../services/videosServices';
import { VideoPageType } from '../../../constants/videoPage';

export const useVideo = (page: VideoPageType) => {
  const [videoData, setVideoData] = useState<VideoCategory[]>([]);

  const getVideos = async () => {
    const { categories } = await videosServices.getAllVideos(page);
    setVideoData(categories);
  };

  useEffect(() => {
    getVideos();
  }, [page]);

  return { videoData };
};
